<template>
  <div class="option-size">
    <div
      class="dropdown">
      
    <div class="descriptor">
      <h5 v-if="getT">{{getT.static.summary[0].size_label}}</h5>
      <p>{{getDimensionLabel(currPool)}}</p>
    </div>
        <div class="dimensions">
          <div class="number-switch"
              :style="{ 'transform': `translateY(${ -1 * (currPool.options.len.choices.indexOf(selectedChoice('len'))) }em)` }">
            <span
              v-for="(choice) of currPool.options.len.choices"
              v-bind:key="choice.id"
              class="dimension-value"
              :class="{ 'show': selectedChoice('len') == choice }">
              <span>{{choice.measurement}}</span>
            </span>
          </div><span class="unit-and-x">{{ currPool.options.len.unit ? currPool.options.len.unit : "'" }} 
            {{ getT.options.size[0].length_label_abbreviation }} x </span>
          <div class="number-switch"
              :style="{ 'transform': `translateY(${ -1 * (currPool.options.width.choices.indexOf(selectedChoice('width'))) }em)` }">
            <span
              v-for="(choice) of currPool.options.width.choices"
              v-bind:key="choice.id"
              class="dimension-value"
              :class="{ 'show': selectedChoice('width') == choice }">
              <span>{{choice.measurement}}</span>
            </span>
          </div><span class="unit-and-x">{{ currPool.options.width.unit ? currPool.options.width.unit : "'" }} 
            {{ getT.options.size[0].width_label_abbreviation }} x </span>
          <div class="number-switch"
              :style="{ 'transform': `translateY(${ -1 * (currPool.options.depth.choices.indexOf(selectedChoice('depth'))) }em)` }">
            <span
              v-for="(choice) of currPool.options.depth.choices"
              v-bind:key="choice.id"
              class="dimension-value"
              :class="{ 'show': selectedChoice('depth') == choice }">
              <span>{{choice.measurement}}</span>
              </span>
          </div><span class="unit-and-x">{{ currPool.options.depth.unit ? currPool.options.depth.unit : '"' }} 
            {{getT.options.size[0].height_label_abbreviation}}</span>
        </div>
    </div>
    <div v-if="sizeConfigurable"
      class="dropdown-content showDropdown">
      <OptionToggle
        class="secondary"
        :suffix='currPool.options.depth.unit ? currPool.options.depth.unit : "\""'
        @measurementClick="logDepth($event, currPool)"
        optionId="depth"/>
    </div>
  </div>
</template>
<script>
import OptionToggle from './OptionToggle';
import { mapGetters } from 'vuex';
import { categoryOfPool } from '../../poolData';

export default {
  name: 'OptionSize',
  data() {
    return {
      contentHeight: 0,
    };
  },
  computed: {
    sizeConfigurable: function() {
      return this.currPool.options.len.choices.length > 1 || 
        this.currPool.options.width.choices.length > 1 || 
        this.currPool.options.depth.choices.length > 1;
    },
    ...mapGetters(['getT', 'currPool', 'selections']),
  },
  components: {
    OptionToggle,
  },
  methods: {
    getDimensionLabel(model) {
      if (categoryOfPool(model.tag)?.tag == 'custom' && model.tag != 'sp105') {
        return this.getT.static.pool_select[0].model_select[0]
        .interior_dimensions_label
      } else {
        return this.getT.static.pool_select[0].model_select[0]
        .overall_dimensions_label
      }
    },
    selectedChoice(dim) {
      const selectedChoiceId = this.selections[dim].value;
      const theChoiceObj = this.currPool.options[dim].choices.find(c => c.id === selectedChoiceId);
      return theChoiceObj;
    },
    logLength($event, model){
      // track event for Google Analytics
      this.$gtag.event($event + '\' Length Selected', {
        'event_category': 'Size Option Selection',
        'event_label': $event + '\' Length Selected',
        'selected_pool': model.title
      });
    },
    logWidth($event, model){
      // track event for Google Analytics
      this.$gtag.event($event + '\' Width Selected', {
        'event_category': 'Size Option Selection',
        'event_label': $event + '\' Width Selected',
        'selected_pool': model.title
      });
    },
    logDepth($event, model){
      // track event for Google Analytics
      this.$gtag.event($event + '\' Depth Selected', {
        'event_category': 'Size Option Selection',
        'event_label': $event + '\' Depth Selected',
        'selected_pool': model.title
      });
    },
  }
}
</script>
<style scoped lang="scss">
.option-size {
  display: flex;
  flex-direction: column;
  .dropdown {
    width: 100%;
    min-height: 4.5em;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1em;
    border-bottom: 1px solid $deep-slate;
    .descriptor {
      h5 {
        min-width: 5em;
        color: white;
      }
      p {
        color: $muted-white;
        font-family: 'Europa Bold';
        font-size: .8rem;
        letter-spacing: 1px;
      }
    }
    .dimensions {
      color: $muted-white;
      letter-spacing: 1px;
      user-select: none;
      .number-switch {
        // 1px = fake letter spacing
        margin-right: 1px;
        height: 1em;
        display: inline-flex;
        flex-direction: column;
        transition: transform 200ms cubic-bezier(0.645, 0.045, 0.355, 1);
        .dimension-value {
          color: white;
          transition: opacity 200ms cubic-bezier(0.645, 0.045, 0.355, 1);
          opacity: 0;
          pointer-events: none;
          line-height: 1em;
          text-align: right;
          &.show {
            opacity: 1;
          }
        }
        @for $k from 1 through 10 {
          .dimension-value:nth-child(#{ $k }) {
            top: ($k - 1) * 1rem;
          }
        }
      }
    }
  }
  .dropdown-content {
    height: auto;
    transition: max-height 350ms cubic-bezier(0.455, 0.03, 0.515, 0.955) 0ms;
    max-height: 30em;
    overflow: hidden;
    user-select: none;
  }
}
</style>
